export function generateEndpointBroadcast() {
    return `/cosmos/tx/v1beta1/txs`;
}
export var BroadcastMode;
(function (BroadcastMode) {
    BroadcastMode["Unspecified"] = "BROADCAST_MODE_UNSPECIFIED";
    BroadcastMode["Block"] = "BROADCAST_MODE_BLOCK";
    BroadcastMode["Sync"] = "BROADCAST_MODE_SYNC";
    BroadcastMode["Async"] = "BROADCAST_MODE_ASYNC";
})(BroadcastMode || (BroadcastMode = {}));
export function generatePostBodyBroadcast(txRaw, broadcastMode = BroadcastMode.Sync) {
    return `{ "tx_bytes": [${txRaw.message
        .toBinary()
        .toString()}], "mode": "${broadcastMode}" }`;
}
//# sourceMappingURL=broadcast.js.map